import msdyn365Commerce, { IImageDimension, IViewPort } from '@msdyn365-commerce/core-internal';
import { useMemo } from 'react';

export type BaseImageSettings = {
    [K in keyof IViewPort]: Pick<IImageDimension, 'h' | 'w'>;
};

const MAX_DPR_VALUE = 2;
const MIN_DPR_VALUE = 1;

const getParsedImageViewportSettings = (simpleSettings: BaseImageSettings): IViewPort => {
    const dpr = msdyn365Commerce.isBrowser ? Math.min(Math.round(window?.devicePixelRatio || MIN_DPR_VALUE), MAX_DPR_VALUE) : MIN_DPR_VALUE;
    return Object.entries(simpleSettings).reduce((acc, [key, val]) => {
        return { ...acc, [key]: { ...val, q: `w=${val.w * dpr}&h=${val.h * dpr}&m=6&f=webp&q=80` } };
    }, {} as IViewPort);
};

export const useImageSettings = (baseSettings: BaseImageSettings) => {
    const baseDpr = typeof window === 'undefined' ? MAX_DPR_VALUE : window.devicePixelRatio;
    const imageViewportSettings = useMemo(() => getParsedImageViewportSettings(baseSettings), [baseDpr]);

    return imageViewportSettings;
};
